<p-table #table
    [value]="date_calendario"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
    styleClass="scheda-tabella p-datatable-sm"
    [paginator]="true"
    [showCurrentPageReport]="true"
    [rowHover]="true"
    [globalFilterFields]="['data', 'orario']"
    currentPageReportTemplate="{first} di {last} su {totalRecords} date"
    [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-3 w-full">
            <div class="lg:w-3/4 w-full">
                <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                    <p-inputicon styleClass="bi bi-search" />
                    <input type="text" pInputText (input)="onGlobalFilter(table, $event)" placeholder="Cerca date…" [style]="{'width': '100%'}" />
                </p-iconfield>
            </div>
            <div class="lg:w-1/4 w-full table-toolbar-btns">
                <button class="flex-1 acc-btn" type="button" (click)="add = true">
                    <i class="bi bi-plus"></i>
                    Aggiungi data
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th class="w-1/12"></th>
            <th class="w-5/12">Data</th>
            <th class="w-4/12">Orario</th>
            <th class="w-2/12 text-center">Azioni</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-calendario let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td class="text-center">
                <i class="bi bi-list text-2xl hover:text-black cursor-grab" pReorderableRowHandle></i>
            </td>
            <td><span class="cell-nome">{{calendario.data | date: 'dd/MM/yyyy'}}</span></td>
            <td>{{calendario.orario}}</td>
            <td class="text-center">
                <div class="table-actions">
                    <i class="bi bi-pencil" (click)="onOpenEdit(calendario)" pTooltip="Modifica" tooltipPosition="bottom"></i>
                    <p-divider layout="vertical"></p-divider>
                    <ng-container *ngIf="calendario.id">
                        <p-confirmPopup #deleteCalendario>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDelete()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDelete($event, calendario, index)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                    </ng-container>
                    <ng-container *ngIf="!calendario.id">
                        <i class="bi bi-trash" (click)="date_calendario.splice(index, 1)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                    </ng-container>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4">Nessuna data calendario presente.</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [visible]="(add || edit)" [style]="{width: '50%'}" [focusOnShow]="false" [header]="add ? 'Aggiungi data calendario' : 'Modifica data calendario'" [modal]="true" styleClass="accrediti-dialog" (visibleChange)="onCloseModal();">
    <ng-template pTemplate="content">
        <form [formGroup]="formCalendario" class="accrediti-form flex flex-col gap-6">
            <div class="flex lg:flex-row flex-col gap-4">
                <div class="fld flex-1">
                    <label>* Data</label>
                    <p-calendar formControlName="data" dateFormat="dd/mm/yy" appendTo="body" [showIcon]="true" styleClass="w-full" />
                </div>
                <div class="fld flex-1">
                    <label>Orario</label>
                    <p-calendar formControlName="orario" [timeOnly]="true" appendTo="body" [showIcon]="true" styleClass="w-full" />
                </div>
            </div>
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" (click)="onCloseModal()">Annulla</button>
                @if (add) {
                    <button type="button" class="acc-btn" [disabled]="!formCalendario.valid" (click)="onAdd(true)">Aggiungi e continua</button>
                }
                <button type="button" class="acc-btn acc-btn-primary" [disabled]="!formCalendario.valid" (click)="add ? onAdd(false) : onEdit()">{{add ? 'Aggiungi' : 'Modifica'}}</button>
            </div>
        </form>
    </ng-template>
</p-dialog>
